import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { userCanAccessFeature, planFeatureFallbackPath } from '@/lib/plan-access';

export default function RequirePlanFeature({ feature, children, fallback }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (userCanAccessFeature(user, feature)) {
    return children;
  }

  const target = fallback || planFeatureFallbackPath(user, feature);
  return <Navigate to={target} replace state={{ planRequired: feature }} />;
}
